import React from 'react'
import styles from './style.module.css'
import ContactImg2 from '../../assets/ContactImg2.jpg'
import ContactImg3 from '../../assets/ContactImg3.png'
import ContactImg4 from '../../assets/ContactImg4.png'
import ContactImg5 from '../../assets/ContactImg5.png'
const ContactUs = () => {
  return (
   <>
   <section className={styles.upperSection}>
    <img className=''
     src={ContactImg2}></img>
   </section>
   <section className=''>
   <div className="mainContainer-fluid">
        <div className="row contact-section">
            {/* Left: Image Section  */}
            <div className="col-lg-6">
               
                <img className="img-fluid w-100 h-100"
                src={ContactImg4}
                style={{ borderRadius: "0 45px 0 0px" }} 
                alt="Contact"
                ></img>
            </div>

             {/* Right: Contact Form  */}
            <div className="col-lg-6 col-md-12  p-5">
                <h2 className="text-center mb-4 fs-1 fs-md-2 fs-lg-3">Contact Us</h2>
                <form>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">First Name</label>
                            <input type="text" className="form-control" placeholder="Enter First Name"/>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label className="form-label">Last Name</label>
                            <input type="text" className="form-control" placeholder="Enter Last Name" />

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label className="form-label">Email Address</label>
                            <input type="email" className="form-control" placeholder="Enter Email" />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label className="form-label">Phone Number</label>
                            <input type="tel" className="form-control" placeholder="Enter Phone Number" />
                        </div>
                    </div>

                    <div class="mb-3">
                        <label className="form-label">Your Message</label>
                        <textarea className="form-control" rows="4" placeholder="Enter your message"></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary w-100">Send Message</button>
                </form>
            </div>
        </div>
    </div>
   </section>
   <section className="container my-5 shadow-lg p-4 bg-white rounded">
      <div className="row align-items-center">
        {/* Left Side: Contact Information */}
        <div className="col-lg-6 col-md-12 p-4">
          <h2 className="mb-3 fs-1 fs-md-2 fs-lg-3">Toronto, Canada Office</h2>
          <p><strong>Address</strong></p>
          <p>
            Intelligent Office<br />
            King Street Office 100 West Suite 5700,<br />
            Toronto, Ontario M5X 1C7, CANADA
          </p>
          <p><strong>Phone Number</strong></p>
          <p>416-915-4277, 647-966-4783</p>
          <p><strong>Email</strong></p>
          <p><a href="mailto:info@dpbglobal.com" className="text-decoration-none text-primary">info@dpbglobal.com</a></p>
        </div>

        {/* Right Side: Image */}
        <div className="col-lg-6 col-md-12">
          <img 
            src={ContactImg5} 
            alt="Toronto Office" 
            className="img-fluid w-100 h-100" 
            style={{ objectFit: "cover", borderRadius: "10px" }} 
          />
        </div>
      </div>
    </section>

   </>
  )
}

export default ContactUs